import { InjectionToken } from '@angular/core';
import { DemoApiConfig } from './demo-api.types';

export const DEMO_API_CONFIG = new InjectionToken<DemoApiConfig>(
  'DEMO_API_CONFIG',
);
